import { useState } from "react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

export function AddEventDialog({ open, onOpenChange, member, defaultDate, onCreated }) {
  const [f, setF] = useState({ title: "", start: "09:00", end: "10:00", notes: "" });
  const [date, setDate] = useState(defaultDate);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const set = (k) => (e) => setF((x) => ({ ...x, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    try {
      const { data } = await api.post("/calendar/events", { ...f, date: date || defaultDate, user_id: member.id });
      toast.success("Añadido al calendario");
      setF({ title: "", start: "09:00", end: "10:00", notes: "" });
      onCreated(data);
    } catch (e2) {
      setErr(formatApiErrorDetail(e2?.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  const cls = "h-11 rounded-none border-black";
  return (
    <Dialog open={open} onOpenChange={(v) => { onOpenChange(v); setErr(""); setDate(defaultDate); }}>
      <DialogContent className="rounded-none border-2 border-black max-w-md" data-testid="add-event-dialog">
        <DialogHeader>
          <DialogTitle className="font-display">Añadir al calendario de {member?.name}</DialogTitle>
          <DialogDescription>Solo se guarda si está libre a esa hora.</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-3">
          <Input required maxLength={120} value={f.title} onChange={set("title")} placeholder="Ej.: Reunión facturación" className={cls} data-testid="event-title" />
          <div className="grid grid-cols-3 gap-2">
            <Input type="date" required value={date || defaultDate} onChange={(e) => setDate(e.target.value)} className={`${cls} col-span-3 sm:col-span-1`} data-testid="event-date" />
            <Input type="time" required value={f.start} onChange={set("start")} className={cls} data-testid="event-start" />
            <Input type="time" required value={f.end} onChange={set("end")} className={cls} data-testid="event-end" />
          </div>
          <Input maxLength={500} value={f.notes} onChange={set("notes")} placeholder="Detalles (opcional)" className={cls} data-testid="event-notes" />
          {err && <p className="text-sm text-red-700 bg-red-50 border border-red-300 p-2" data-testid="event-error">{err}</p>}
          <button type="submit" disabled={busy} className="w-full h-11 bg-black text-white text-xs font-semibold uppercase tracking-widest hover:bg-[#E63946] transition-colors disabled:opacity-50 inline-flex items-center justify-center gap-2" data-testid="event-submit">
            {busy && <Loader2 className="animate-spin" size={14} />} Guardar
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
